import type {ReactNode} from 'react';
import {memo} from 'react';

import {Navigation} from '../navigation/index.js';
import {Toolbar} from '../toolbar/index.js';
import * as styles from './style.css.js';

type ShellProps = {
  children: ReactNode;
};

export const Shell = memo(function Shell({children}: ShellProps) {
  return (
    <div className={styles.container}>
      <Navigation />
      <div className={styles.mainContainer}>
        <Toolbar />
        <main className={styles.mainContent}>{children}</main>
      </div>
    </div>
  );
});
